import * as React from 'react';

import GrowthDiscoveryEpicClient from 'bundles/epic/clients/GrowthDiscovery';

type UnifiedPageRolloutContextType = {
  isInUnifiedPageRollout: boolean;
};

export const UnifiedPageRolloutContext = React.createContext<UnifiedPageRolloutContextType>({
  isInUnifiedPageRollout: false,
});

export const useIsInUnifiedPageRollout = (): boolean => {
  const { isInUnifiedPageRollout } = React.useContext(UnifiedPageRolloutContext);
  return isInUnifiedPageRollout;
};

const UnifiedPageRolloutExperimentDataProvider = ({ children }: { children: React.ReactNode }) => {
  const [value] = React.useState(() => ({
    isInUnifiedPageRollout: GrowthDiscoveryEpicClient.preview('orgScopedHome'),
  }));

  return <UnifiedPageRolloutContext.Provider value={value}>{children}</UnifiedPageRolloutContext.Provider>;
};

export default UnifiedPageRolloutExperimentDataProvider;
